// ════════════════════════════════════════════════════════════════════════════
//  features/fiscal/transporte/services/averbacaoService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { MovAverbacaoDto, AverbacaoResultadoDto, AverbarRequest } from '../types';

const BASE = '/api/averbacao';

/** Filtros server-side do histórico (status = nome do StatusAverbacaoEnum: Processado, Pendente…). */
export interface FiltrosAverbacao {
  busca?:    string;
  dtInicio?: string;
  dtFim?:    string;
  status?:   string;
}

export const averbacaoService = {
  historico: (pagina = 1, tamanhoPagina = 20, filtros: FiltrosAverbacao = {}) =>
    apiClient
      .get<{ itens: MovAverbacaoDto[]; total: number; totalPaginas: number }>(`${BASE}/historico`, {
        params: {
          pagina, tamanhoPagina,
          busca:    filtros.busca?.trim() || undefined,
          dtInicio: filtros.dtInicio || undefined,
          dtFim:    filtros.dtFim || undefined,
          status:   filtros.status || undefined,
        },
      })
      .then((r) => r.data),

  obterPorId: (id: number) =>
    apiClient.get<MovAverbacaoDto>(`${BASE}/${id}`).then((r) => r.data),

  averbar: (req: AverbarRequest) =>
    apiClient.post<AverbacaoResultadoDto>(`${BASE}/averbar`, req).then((r) => r.data),

  cancelar: (id: number, motivo: string) =>
    apiClient.post<AverbacaoResultadoDto>(`${BASE}/${id}/cancelar`, { motivo }).then((r) => r.data),
};
